import fr from "./translation/fr";
import en from "./translation/en";
export default {
    fr,
    en,
};